require('./depositMoneyStep1.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');
// @ utilities
const { getCurrencySymbol, getFormattedString } = require('utilities/currencyHelper');
// @ actions
const cardDepositMoneyActions = require('actions/cardDepositMoney');
// @ components
const { AmountInput } = require('commonsComponents/amountInput');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { LoadingSection } = require('commonsComponents/loadingSection');

class DepositMoneyStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleFromAccountChange = this.handleFromAccountChange.bind(this);
    }

    buildDropdownAccounts(fromAccount) {
        const { immAccounts, isInactiveAccountsEnabled, accountsIndexes, immStep } = this.props;
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';

        const filteredAccounts = immAccounts.filter(account => account.get('accountType') !== '803');
        const filteredAccountsList = filteredAccounts.toJS();
        const filteredAccountsIndexes = accountsIndexes.filter(index => filteredAccountsList.hasOwnProperty(index));

        if ( immAccounts.size ){
            const fromAccountAlertVisible = immStep.get('fromAccountIsDirty') && !fromAccount; // eliminar condicion del componente
            return (
                <DropdownAccounts
                    label={formatText('cardDepositMoney-chargeAccount')}
                    id="drd_DepositMoneyStep1_Account"
                    immAccounts={immAccounts}
                    accountsIndexes={filteredAccountsIndexes}
                    currentAccountId={fromAccount}
                    onAccountChange={this.handleFromAccountChange}
                    error={fromAccountAlertVisible}
                    errorMsg={formatText('cardDepositMoney-validationError')}
                    showAvailableBalance={true}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    tooltipMsg={tooltipMsgContent}
                />
            );
        } else {
            return (<LoadingSection/>);
        }
    }

    handleFromAccountChange(fromAccount) {
        const { immAccounts, setFromAccount } = this.props;
        const immAccount = immAccounts.get(fromAccount);
        setFromAccount(fromAccount, immAccount ? immAccount.getIn(['balances', 'availableBalance', 'amount']) : 0);
    }

    render() {
        const { immCard, immStep, handleAmountChange, immCardsPaymentCycle , cardsPaymentCycleEnabled} = this.props;
        const fromAccount = immStep.get('fromAccount');
        const amount = immStep.get('amount');
        const currency = getCurrencySymbol(immCard.get('balanceDrawn'));
        const dropdownAccounts = this.buildDropdownAccounts(fromAccount);
        const formattedTotalContractBalanceDrawn = getFormattedString(immCard.get('totalContractBalanceDrawn'));
        const increasingAvailableText = immCard.get('isViaT') ? 'cardDepositMoney-increasingAvailableViaT' : 'cardDepositMoney-increasingAvailable';
        const cardsPaymentCycleWarningMessage = formatText('cardDepositMoney-cardDepositMoney_paymentCycleDisclamerMessage');
        const showTransferDisclaimer = immCardsPaymentCycle.get('showTransferDisclaimer');
        const errorMsg = immStep.get('errorMessage');
        const amountIsDirty = immStep.get('amountIsDirty');
        let disclaimerMessageContent;
        if(showTransferDisclaimer && cardsPaymentCycleEnabled) {
            disclaimerMessageContent = (
                <div className="deposit-money-step-one__disclamer">
                    <OKMessage type="informative">
                        {cardsPaymentCycleWarningMessage}
                    </OKMessage>
                </div>
            )
        }

        return (
            <article className="deposit-money-step-one">
                <header className="deposit-money-step-one__header">
                    <FormattedText value="cardDepositMoney-moneyIncomeData" className="deposit-money-step-one__title" />
                </header>
                {disclaimerMessageContent}
                <section className="deposit-money-step-one__content">
                    <FormattedText value={increasingAvailableText} />
                    <div className="deposit-money-step-one__form">
                        <fieldset className="deposit-money-step-one__field">
                            {dropdownAccounts}
                        </fieldset>
                        <fieldset className="deposit-money-step-one__field">
                            <label>
                                <FormattedText value="cardDepositMoney-amountToBePaid" className="deposit-money-step-one__label" />
                                <AmountInput
                                    id="inp_DepositMoneyStep1_Amount"
                                    callback={handleAmountChange}
                                    min={0}
                                    showBlurZero
                                    hideFocusZero
                                    disablePaste
                                    errorMsg={errorMsg}
                                    error={amountIsDirty}
                                    amount={amount}
                                    language={getLanguage()}
                                />
                            </label>
                            <span className="deposit-money-step-one__currency">
                                {currency}
                            </span>
                            <FormattedText value="cardDepositMoney-toMax" className="deposit-money-step-one__clarification" injectedStrings={[formattedTotalContractBalanceDrawn]} />
                        </fieldset>
                    </div>
                </section>
            </article>
        )
    }
}

DepositMoneyStep1.propTypes = {
    accountsIndexes: PropTypes.array,
    cardsPaymentCycleEnabled: PropTypes.bool,
    handleAmountChange: PropTypes.func,
    immAccounts: PropTypes.object,
    immCard: PropTypes.object,
    immCardsPaymentCycle: PropTypes.object,
    immStep: PropTypes.object,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setFromAccount: PropTypes.func,
};

module.exports.constructor = DepositMoneyStep1;
module.exports.DepositMoneyStep1 = connect(null,
    {
        handleAmountChange: cardDepositMoneyActions.setAmount,
        setFromAccount: cardDepositMoneyActions.setFromAccount,
    }
)(DepositMoneyStep1);